var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
	
$(document).ready(function() {
	masonry_init();
	popups_init();
	mobile_init();
	$('input, textarea').placeholder();
	$('.comment-panel .share').find('.col-1').on('mouseenter', function() {
		$(this).parent().parent().find('.arrow').addClass('col1-arrow')
	}).on('mouseleave', function() {
		$(this).parent().parent().find('.arrow').removeClass('col1-arrow')
	});
});




// Masonry

function masonry_init() {
	var $container = $('#category-panel').masonry();
	$container.imagesLoaded( function() {
		$container.masonry({
			columnWidth: 295,
			itemSelector: '.panel',
			gutter: 10
		});
	});
	$('.panel').css({
		'opacity': 0
	});
}

$(window).load(function() {
	$('.panel').animate({opacity: 1});
});

function popups_init() {
	$('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
	});
}

$(document).ready(function() {
		$menuLeft = $('.pushmenu-left');
		$nav_list = $('#nav-triggers');
		
		$nav_list.click(function() {
			$(this).toggleClass('active');
			$('.pushmenu-push').toggleClass('pushmenu-push-toright');
			$menuLeft.toggleClass('pushmenu-open');
		});
	});

function mobile_init() {
	$('#top-header').prepend('<div class="mobile-menu-bg"></div>');
	var menu =  $('.menu');
	var navbar = $('.nav-bar');
	var navi = $('.nav-menu');
	var naviUL = navi.find('ul');
	menu.on('click', function() {
		goToByScroll('top-header')
		if (naviUL.height() === 0) {
			var curHeight = naviUL.height();
			naviUL.css('height', 'auto');
			var autoHeight = naviUL.height();
			naviUL.height(curHeight).animate({
				height : autoHeight									 
			}, 300);	
			navbar.addClass('active');
			$('.mobile-menu-bg').fadeIn();
		} else {
			naviUL.height(curHeight).animate({
				height : 0								 
			}, 300, function() {
				navbar.removeClass('active');
			});
			$('.mobile-menu-bg').hide();
		}
		return false;
	});
	if (isMobile) {
		navi.on('click', function() {
			if (naviUL.height() === 0) {
				var curHeight = naviUL.height();
				naviUL.css('height', 'auto');
				var autoHeight = naviUL.height();
				naviUL.height(curHeight).animate({
					height : autoHeight									 
				}, 300);	
				navbar.addClass('active');
				$('.mobile-menu-bg').fadeIn();
			} else {
				naviUL.height(curHeight).animate({
					height : 0								 
				}, 300, function() {
					navbar.removeClass('active');
				});
				$('.mobile-menu-bg').hide();
			}
			return false;
		})
	}
}


function goToByScroll(id){
    $('html,body').animate({scrollTop: $("#"+id).offset().top},'fast');
}


// 

 $(document).ready(function() {
        $('.search_btn').click(function() {
                $('.search_content').slideToggle("slow");
        });


         $('.pushme').click( function() {
		    $("#white-transparent").toggleClass("enable-map");
		     $(this).text(function(i, v){
               return v === 'Enable Map' ? 'Disable Map' : 'Enable Map'
            })
		});

         $('#white-transparent').click( function() {
		    $(this).addClass("enable-map");
		     $('.pushme').text(function(i, v){
               return v === 'Disable Map' ? 'Disable Map' : 'Disable Map'
            })
		});

    });